<template>
    <transition name="modal-fade">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop>
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>


                <div class="col-12 title" v-if="ClientContracts!=null && ClientContracts.length > 0" style="margin-top:8px;   font-weight:bold; text-align:center;">
                    {{ProjectName}}
                </div>
                <div class="col-12" style="color:gray; text-align:center;" v-if="IsOwner">Client Contracts</div>
                <div class="col-12" style="color:gray; text-align:center;" v-if="!IsOwner">Contracts Received</div>

                <div v-for="(contract) in getLatestAmendedList()" class="col-12 contract-box" v-bind:key="contract" :class="contract.Status == 'Draft'? 'draft-box':''">

                     
                    <div style="flex: 1;">

                        <div v-if="contract.OriginalId == null">
                             <div v-if="contract.Status == 'Draft'" class="file-name white-box" @click="editClientContract(ProjectId, getLatestAmendedData(contract).Id, getLatestAmendedData(contract).Data, getLatestAmendedData(contract).Token)">
                                {{getContractName(contract)}}

                            </div>
                            <div v-else-if="contract.Status == 'Signed'" class="file-name white-box" @click="openContract(contract.SignedPdf)">
                                {{getContractName(contract)}}
                            </div>
                            <div v-else class="file-name white-box" @click="openContract(contract.OrignalPdf)">
                                {{getContractName(contract)}}
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="contract.Status == 'Draft'" class="file-name white-box" @click="editClientContract(ProjectId, getLatestAmendedData(contract).Id, getLatestAmendedData(contract).Data, getLatestAmendedData(contract).Token)">
                                Amended Agreement - {{getContractName(contract)}}
                            </div>
                            <div v-else-if="contract.Status == 'Signed'" class="file-name white-box" @click="openContract(contract.SignedPdf)">
                                Amended Agreement - {{getContractName(contract)}}

                            </div>
                            <div v-else class="file-name white-box" @click="openContract(contract.OrignalPdf)">
                                Amended Agreement - {{getContractName(contract)}}

                            </div>
                            <n-dropdown :options="menuOptionsForOriginalContracts(contract)" trigger="click" @select="handleSelectForOriginalContracts" style="width:fit-content; border-radius:10px;" placement="bottom-end">

                                <span style="color:green; font-size:10px; cursor:pointer;">Original Contracts</span>

                            </n-dropdown>

                        </div>

                        <slot v-if="getLatestAmendedData(contract).Status == 'Draft'"></slot>
                        <slot v-else-if="getLatestAmendedData(contract).Status == 'Signed'">
                            <div class="signed-box" @click="openContract(getLatestAmendedData(contract).SignedPdf)"><i class="material-icons">check_circle_outline</i> Signed - {{getLatestAmendedData(contract).CreatedDate}}</div>
                        </slot>
                        <slot v-else>
                            <slot v-for="party in getLatestAmendedData(contract).Parties.filter(x=> x.Type != 0 )" v-bind:key="party">
                                <div class="signed-box" v-if="party.SignedTime !== null">
                                    <i class="material-icons">check_circle_outline</i> {{party.BusinessName.substring(0, 10) + "..."}} Signed
                                    <ii class="material-icons material-symbols-outlined">visibility</ii>
                                    <sup>{{contract.PartyBViews}}</sup>
                                </div>
                                <div class="unsigned-box" v-if="party.SignedTime === null && IsOwner" @click="openSignContract(getLatestAmendedData(contract))">
                                    <i class="material-icons">radio_button_unchecked</i> {{party.BusinessName.substring(0, 10) + "..."}} Unsigned
                                    <ii class="material-icons material-symbols-outlined">visibility</ii>
                                    <sup>{{contract.PartyBViews}}</sup>
                                </div>
                                <div class="unsigned-box" v-if="party.SignedTime === null && !IsOwner" @click="openUrl(getLatestAmendedData(contract).SignatureUrl)">
                                    <i class="material-icons">radio_button_unchecked</i> Sign Now</div>

                            </slot>
                        </slot>

                        <!--
                            <div class="signed-box" v-if="getLatestAmendedData(contract).Status == 'Signed'" @click="openContract(getLatestAmendedData(contract).SignedPdf)"><span class="material-icons" style="color:darkgreen; font-size:14px;">check_circle_outline</span>Signed - {{getLatestAmendedData(contract).CreatedDate}}</div>
                            <div class="unsigned-box" v-if="getLatestAmendedData(contract).Status != 'Signed' && IsOwner" @click="openSignContract(getLatestAmendedData(contract))"> Unsigned</div>
                            <div class="unsigned-box" v-if="getLatestAmendedData(contract).Status != 'Signed' && !IsOwner" @click="openUrl(getLatestAmendedData(contract).SignatureUrl)"> Sign Now</div>
                        -->

                    </div>
                    <div v-if="(getLatestAmendedData(contract).Data.Payment.Mode == 'percentage' || getLatestAmendedData(contract).Data.Payment.Mode == 'milestone') && getLatestAmendedData(contract).Status == 'Signed'" style="align-content: center;">
                        <i class="material-icons" style="color: #ffa24b;" @click="showReminder(getLatestAmendedData(contract))">notifications</i>
                    </div>
                    <div v-if="IsOwner && getLatestAmendedData(contract).Status == 'Signed' && getLatestAmendedData(contract).Data.Payment.Deposit > 0" class="deposit-received-toggle" style="align-content: center;">
                        <label>
                            <input type="checkbox" :checked="getLatestAmendedData(contract).IsDepositReceived" @change="onToggleDepositReceived(getLatestAmendedData(contract), $event)" />
                            <span>Deposit received</span>
                        </label>
                    </div>
                    <div style="align-content: center;">
                        <div v-if="contract.Status == 'Draft'"  class="expired-text">Draft Contract</div>
                        <div v-else-if="getLatestAmendedData(contract).IsExpired && getLatestAmendedData(contract).Status != 'Signed'"  class="expired-text">Contract Expired</div>
                        
                        <n-dropdown :options="menuOptionsForItem(contract)" trigger="click" @select="handleSelect" style="width:fit-content; border-radius:10px;" v-if="IsOwner" placement="bottom-end" :render-label="renderDropdownLabel" :disabled="$core.data.UserInfo.Metadata?.IsRestricted">

                            <div class="purple-button" style="line-height: 24px;">
                                Edit Contract {{$core.data.UserInfo.Metadata?.IsRestricted?'(Unsubscribed)':''}} <i class="icon-dropdown"></i>
                            </div>


                        </n-dropdown>


                        <div style="display:flex; background-color:white; height:fit-content; display:none;" class="border" v-if="IsOwner">
                            <div class="btn-container" @click="editClientContract(ProjectId, getLatestAmendedData(contract).Id, getLatestAmendedData(contract).Data, getLatestAmendedData(contract).Token)">
                                <div class="btn-edit"></div>
                                <div class="small-text">Edit<br />Contract</div>
                            </div>
                            <div class="btn-container" v-if="contract.Status != 'Signed'" @click="cancelContract(getLatestAmendedData(contract).Id, ProjectName + ' - ' + getLatestAmendedData(contract).CreatedDate )">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete<br />Contract</div>
                            </div>
                            <div class="btn-container" v-else style="opacity:.3;">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete<br />Contract</div>
                            </div>
                            <div class="btn-container" @click="resendContract(getLatestAmendedData(contract).Id)">
                                <div class="btn-send"></div>
                                <div class="small-text">Resend<br />Contract</div>
                            </div>
                        </div>

                        <div style="display:flex; background-color:white; height:fit-content; opacity:.3; display:none;" class="border" v-else>
                            <div class="btn-container">
                                <div class="btn-edit"></div>
                                <div class="small-text">Edit<br />Contract</div>
                            </div>
                            <div class="btn-container">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete<br />Contract</div>
                            </div>
                            <div class="btn-container">
                                <div class="btn-send"></div>
                                <div class="small-text">Send<br />Contract</div>
                            </div>
                        </div>

                    </div>
                    


                </div>

            </div>


            <CustomPopup :visible="showPopup"
                         :icon="popupIcon"
                         :iconSrc="popupIconSrc"
                         :iconColor="iconColor"
                         :title="popupTitle"
                         :content="content"
                         :cancelText="cancelText"
                         :confirmText="confirmText"
                         :confirmButtonType="confirmButtonType"
                         :confirmAction="currentConfirmAction"
                         @cancel="onCancel" />

        </div>
    </transition>

</template>

<script>

    import CustomPopup from './CustomPopup.vue';

    import {fileUrl} from '../../composables/http';

    export default {

        components: { CustomPopup },

        data() {
            return {
                ClientContracts:  [],
                ProjectName: "",
                ProjectId: "",
                Comments: "",
                IsOwner: false,
                menuOptions: [{
                    label: "Edit Contract",
                    key: "edit"

                },

                {
                    label: "Resend Contract",
                    key: "resend"

                },
                {
                    label: "Delete Contract",
                    key: "delete"

                },
                ],

                //Custom Popup

                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,

            }
        },

        computed: {
            OriginalClientContracts() {
                return this.ClientContracts.filter(m => m.OriginalId == null);
            }
        },
        mounted() {
      

        },
       
        methods: {

            showReminder(data) {

                this.$emit('showReminder', data);
            },

            onToggleDepositReceived(contract, e) {
                const received = e.target.checked;
                const url = `/api/app/contract/setdepositreceived?id=${contract.Id}&received=${received}`;
                this.$http.request("put", url).then(res => {
                    if (res?.Type == 200) {
                        contract.IsDepositReceived = received;
                        contract.DepositReceivedTime = received ? new Date().toISOString() : null;
                    } else {
                        e.target.checked = !received;
                    }
                }).catch(() => { e.target.checked = !received; });
            },

            parsePaymentTerms(paymentTerms) {

                //console.log("parsePaymentTerms", paymentTerms); 

                let obj = JSON.parse(paymentTerms);

                //console.log("parsePaymentTerms", obj);

                return obj;
            },
            renderDropdownLabel(option) {
                const { key, item } = JSON.parse(option.key);

                //console.log("renderDropdownLabel", key, item);

                var iconCss = "btn-new";

                switch (key) {
                    case 'makecontract':
                        iconCss = "btn-new";
                        break;
                    case 'addsub':
                        iconCss = "btn-add-sub";
                        break;
                    case 'edit':
                        iconCss = "btn-edit";
                        break;
                    case 'delete':
                        iconCss = "btn-delete";
                        break;
                    case 'movetoarchive':
                        iconCss = "btn-move";
                        break;
                    case 'resend':
                        iconCss = "btn-move";
                        break;
                    case 'movetopending':
                        iconCss = "btn-move";
                        break;

                }
                var className ="custom-dropdown-option";

                if (key == "edit" && !item.IsEditable){
                    option.disabled = true;  
                    if(option.label.indexOf("NA") == -1)
                        option.label += " NA";                   
                    className += " disabled";
                }
                     
                if(key == "resend" && !item.IsResendable){
                    option.disabled = true;  
                    if(option.label.indexOf("Not Available") == -1)
                        option.label += " (Not Available)";
                    className += " disabled";
                }

                if (key == "delete" && !item.IsDeletable) {
                    option.disabled = true;
                    if (option.label.indexOf("NA") == -1)
                        option.label += " NA";
                    className += " disabled";
                }

                return (
                    <div class={className}>
                        {/* Use className instead of class in JSX */}
                        <span class={iconCss}></span>
                        <span class="custom-option-label">{option.label}</span>
                    </div>
                );
            },
            menuOptionsForItem(item) {
                var options = this.menuOptions.map(option => ({
                    ...option,
                    item,  // Add item reference to each option
                    key: JSON.stringify({ key: option.key, item }),

                }));

                return options;
            },

            menuOptionsForOriginalContracts(contract) {
                 let amendedList = [];
               
                let previousAmended = this.getOriginalContractData(contract.OriginalId);
 
                while (previousAmended.length > 0) {
                    amendedList.push(...previousAmended);
                    previousAmended = this.getOriginalContractData(previousAmended[previousAmended.length - 1].OriginalId);

                    
                }
 
                var options = [];
                for (var i = 0; i < amendedList.length; i++) {
                    options.push({ label: this.getContractName(amendedList[i]), key: amendedList[i].OrignalPdf })
                }
            
                return options;
            },

            handleSelectForOriginalContracts(key) {
                //console.log("handleSelectForOriginalContracts", key);

                this.openContract(key);
            },

            handleSelect(serializedKey) {
                const { key, item } = JSON.parse(serializedKey);

                switch (key) {
                    case 'resend':
                        //this.sendSubcontractor(this.ProjectId, item.Id);
                        var parties = item.Parties;
                        var partiesNames = "";
                        for (var i = 0; i < parties.length; i++) {
                            if(parties[i].Type == 2 && parties[i].SignedTime == null){
                                partiesNames += parties[i].BusinessName ;
                                if(i < parties.length - 1){
                                    partiesNames += " And ";
                                }
                            }
                        }
                        this.resendContract(item.Id, partiesNames);
                        break;

                    case 'edit':
                     
                        this.editClientContract(this.ProjectId, item.Id, item.Data, item.Token);
 
                        break;
                    case 'delete':
                        if (item.Status == 'Signed') {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Error";
                            this.content = "Signed contracts cannot be deleted";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'error';
                            this.currentConfirmAction = null;
 
                        } else {
                            this.cancelContract(item.Id, this.ProjectName + ' - ' + item.CreatedDate);

                        }
                        
                        break;


                }
            },

            // Get all original data (those with no originalId)
            getOriginalData() {
                return this.ClientContracts.filter(contract => contract.OriginalId === null);
            },
            openSignContract(contract) {

                this.$emit('close-modal');
                this.$emit('uploadSigned', contract);

            },
            // Recursively get all amended data for a specific original
            getAllAmendedData(original) {
                let amendedList = [];
                let nextAmended = this.getAmendedData(original.Id);

                while (nextAmended.length > 0) {
                    amendedList.push(...nextAmended);
                    nextAmended = this.getAmendedData(nextAmended[nextAmended.length - 1].Id);
                }

                return amendedList;
            },

            // Get amended data for a specific original id
            getAmendedData(originalId) {
                return this.ClientContracts.filter(contract => contract.OriginalId === originalId);
            },

            getOriginalContractData(originalId) {
                return this.ClientContracts.filter(contract => contract.Id === originalId);
            },

            // Get the latest amended data
            getLatestAmendedData(original) {
                let latestAmended = original;
                let nextAmended = this.getAmendedData(original.Id);

                while (nextAmended.length > 0) {
                    latestAmended = nextAmended[nextAmended.length - 1];
                    nextAmended = this.getAmendedData(latestAmended.Id);
                }

                return latestAmended;
            },

            getLatestAmendedList() {
                // Get all original projects (projects without an originalId)
                let originalProjects = this.getOriginalData();

                    // Map through each original project and get the latest amended data
                var list = originalProjects.map(original => this.getLatestAmendedData(original));

                //console.log("getLatestAmendedList", list);
                return list;
            },

            getContractName(contract) {
                var name = contract.Data.ScopeOfServices?.length > 30 ? contract.Data.ScopeOfServices.substring(0, 30) + '...' : contract.Data.ScopeOfServices;
                name += " " + contract.CreatedDate;

                return name;
            },
            dataUpdate(obj, projectName, projectId, comments, isOwner) {
 
                this.ClientContracts = obj;
                this.ProjectName = projectName;
                this.ProjectId = projectId;
                this.Comments = comments?.length > 30 ? comments?.substring(0, 30) : comments;
                this.IsOwner = isOwner;
                
                console.log("ClientContracts",this.ClientContracts);
            },
            
            openContract(Id) {
                window.open(fileUrl(Id));
            },
            openUrl(url) {
                window.open(url);
            },
            resendContract(contractId, partiesNames) {

                let _this = this;

                this.showPopup = true;

                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/ResendIcon.png'); // Replace with your image path
                this.popupTitle = "Resend Contract";
                this.content = "Are you sure you want to send this contract?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Resend';
                this.confirmButtonType = 'success';

                if(partiesNames){
                    this.content = "Are you sure you want to send this contract to the following recipients: " + partiesNames + "?";
                }

                this.currentConfirmAction = () => {

                    this.showPopup = false;
                    this.$loader.show(null, 30);

                    this.$http.request("put", `/api/app/contract/resend?id=${contractId}`).then((res) => {

                        if (res?.Type == 200) {
                            // this.getProjects();
 
                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null; // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Resent!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;


                        } else {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png');// Replace with your image path
                            this.popupTitle = "Error";
                            this.content = res?.Content;
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'error';

                            this.currentConfirmAction = null;

                        }
                    }).finally(() => {
                        this.$loader.hide();
                    });
                };

               
            },

            editClientContract(projectid, contractid, obj, token) {

                obj.CommencementDate = obj.CommencementDate.substring(0, 10);
                obj.CompletionDate = obj.CompletionDate.substring(0, 10);

                obj.ProjectId = projectid;

                obj.Token = token;
                obj.Id = contractid;
                this.$core.data.SelectedClientContract = obj;
                this.$core.data.DisplayPage = 'Project';
                this.$router.push('/EditClientContract/' + contractid);
            },

            cancelContract(contractId, name) {


                let _this = this;

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                this.popupTitle = "Delete Contract";
                this.content = "Are you sure you want to delete this contract for \"" + name + "\"?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Delete';
                this.confirmButtonType = 'error';

                this.currentConfirmAction = () => {

                    this.showPopup = false;
                    this.$loader.show(null, 30);

                    this.$http.request("put", `/api/app/contract/cancel?id=${contractId}`).then((res) => {

                        if (res?.Type == 200) {
                            // this.getProjects();
                              
                            this.ClientContracts = this.ClientContracts.filter(m => m.Id != contractId);


                            this.showPopup = true;


                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null; // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Deleted!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';

                            this.currentConfirmAction = null;

                            this.$emit('refresh');

                            if(this.ClientContracts.length == 0){
                                this.$emit('close-modal');
                            }
                           
                        }
                    }).finally(() => {
                        this.$loader.hide();
                    });
                };

           
            },

            onCancel() {
                this.showPopup = false;
            },

        }
    }
</script>

<style scoped>
    
    .border {
        border: 1px solid #ccc !important;
        border-radius: 10px;
    }
    .contract-box {
        border-radius: 10px;
        padding: 6px;
        margin: 6px 0;
        box-shadow: rgba(0,0,0,.2) 1px 1px;
        -webkit-box-shadow: rgba(0,0,0,.2) 1px 1px;
        display: flex;
        flex-wrap: wrap;
        background-color: #f1f2f6;
    }

    .draft-box {
        background-color: #ff000044 !important;
    }
    .modal-overlay {
        z-index: 999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
 
    }

    .modal-content {
        background-color: white;
        height: auto;
        width: 800px;
        max-width: 90vh;
        max-height: 90vh;
        margin-top: 5%;
        padding: 0px 24px;
        border-radius: 20px;
        overflow: auto;
    } 

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .deposit-received-toggle {
        font-size: 12px;
        padding: 0 8px;
    }
    .deposit-received-toggle label {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
    }
    .deposit-received-toggle input { cursor: pointer; }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    
</style>